import React, { Fragment } from 'react'

import Link from '../../components/site/typography/Link'
import { redirectWithCookies } from '../../utils/Utm'

import './Footer.scss'

export default function NewFooter() {
    const footerItems = [
        {
            title: 'Mercos', subItems: [
                { name: 'Entrar', url: 'https://app.mercos.com/login/', redirect: true },
                { name: 'Cadastre-se', url: 'https://app.mercos.com/cadastro/', redirect: true },
                { name: 'Integrações', url: 'https://mercos.com/integracao-erp/', redirect: false },
                { name: 'Trabalhe Conosco', url: 'https://mercos.gupy.io/', redirect: false, target: '_blank' },
                { name: 'Sobre nós', url: 'https://mercos.com/sobre/', redirect: false },
                { name: 'Aviso de Privacidade', url: 'https://mercos.com/aviso-de-privacidade/', redirect: false, target: '_blank' },
                { name: 'Portal de Privacidade', url: 'https://www.privacidade.com.br/portal-de-privacidade/?token=511f11a2aed639b807ca96fea6935b2a&site_url=https://mercos.com/', redirect: false, target: '_blank' },
                { name: 'Relatório de Igualdade Salarial', url: '/documentos/relatorio-igualdade-salarial-mercos.pdf', redirect: false, target: '_blank' },
            ]
        },
        {
            title: 'Software', subItems: [
                { name: 'Indústrias', url: 'https://mercos.com/industrias/', redirect: false },
                { name: 'Distribuidoras', url: 'https://mercos.com/distribuidoras/', redirect: false },
                { name: 'Representantes', url: 'https://mercos.com/representantes-comerciais/', redirect: false },
                { name: 'E-commerce B2B', url: 'https://mercos.com/e-commerce-b2b/', redirect: false, },
                { name: 'Mercos Pay', url: 'https://mercos.com/mercos-pay', redirect: false, target: '_blank' },
                {
                    name: 'Força de vendas',
                    url: 'https://mercos.com/forca-vendas/',
                    redirect: false,
                    h4: true,
                    target: '_self'
                },
            ]
        },
        {
            title: 'Conteúdo', subItems: [

                { name: 'Nosso Blog', url: 'https://blog.mercos.com/', redirect: false },
                {
                    name: 'Mercoscast',
                    url: 'https://www.youtube.com/playlist?list=PLjAquKgGC5hWUNcPIdp4bntu9zcQLwTYI',
                    redirect: false
                },
                {
                    name: <Fragment>E-commerce B2B:<br/> O que é?</Fragment>,
                    url: 'https://blog.mercos.com/e-commerce-b2b-o-que-e',
                    redirect: false,
                    h4: true,
                    target: '_blank'
                },
            ]
        },
        {
            title: 'Ajuda', subItems: [
                { name: 'Central de ajuda', url: 'https://ajuda.mercos.com/portal/pt-br/kb', redirect: false },
            ]
        },

    ]

    const footerSection = item => (
        <div className="footer-menu-item">
            <h4 white className="footer-title">{item.title}</h4>
            <ul className="list-unstyled">
                {item.subItems.map(subitem => (
                    <li>
                        {subitem.h4 ?
                            <h4>
                                <Link
                                    className="footer-link-item "
                                    href={subitem.redirect ? null : subitem.url}
                                    onClick={subitem.redirect ? () => redirectWithCookies(subitem.url) : null}
                                    title="Veja como o Mercos pode potencializar sua Indústria."
                                    target={subitem.target}
                                >
                                    {subitem.name}
                                </Link>
                            </h4>
                            :
                            <Link
                                className={"footer-link-item  " + (subitem.greenClass ? subitem.greenClass : null)}
                                href={subitem.redirect ? null : subitem.url}
                                onClick={subitem.redirect ? () => redirectWithCookies(subitem.url) : null}
                                title="Veja como o Mercos pode potencializar sua Indústria."
                                target={subitem.target}
                            >
                                {subitem.name}
                            </Link>
                        }
                    </li>
                ))}
            </ul>
        </div>
    )

    const getContactInfo = () => (
        <div>
            <h5 className="footer-title text-align-center">(47) 3481-8050</h5>
            <h6 className="text-item-block footer-atendimento">
            Segunda a Quinta das 9h às 17h<br/>
            Sexta das 9h30 às 17h
            </h6>
            <div className="footer-apps">
            <a href="https://play.google.com/store/apps/details?id=br.com.meuspedidos&hl=pt_BR" target='_blank' ><img srcSet='/images/site/btn-android.png' alt="Aplicativo Mercos para Android" /></a>
                <a href="https://apps.apple.com/br/app/meus-pedidos/id485511628" target='_blank' ><img srcSet='/images/site/btn-ios.png' alt="Aplicativo Mercos para iOS" /></a>
            </div>
        </div>
    )

    return (
        <div className="container-new-footer-v2">
            <div className="new-footer-bg">
                <div className="new-container new-footer">
                    <div className="footer-container">

                        <div className="footer-details">
                            <div className="footer-menu-item phone-mobile">
                                {getContactInfo()}
                            </div>
                            {footerItems.map(item => footerSection(item))}
                            <div className="footer-menu-item phone-web">
                                {getContactInfo()}
                            </div>
                        </div>
                        <div className="footer-divider-gradient">
                        </div>
                        <div className="footer-about-mercos">
                            <div className="logo-mercos">
                                <Link
                                    href="/"
                                    className="social-media-icon"
                                >
                                    <img src="/images/site/new-home/logo-mercos-nuvini.svg" alt="Logomarca da Mercos" />
                                </Link>
                            </div>
                            <h6 className="cnpj-text">
                                Simplest Software Ltda CNPJ: 12.496.510/0001-80 Insc. Estadual: ISENTO <br /> Av. Rolf Wiest, 277 (4º andar) Bom Retiro - Joinville/SC |
                                CEP: 89223-005

                            </h6>
                            <h6 className="terms">
                                <Link
                                    href="/termos-e-condicoes/"
                                    target="_blank"
                                >
                                    Termos e Condições
                                </Link>
                            </h6>
                            <div className="social-container">
                                <Link
                                    target='_blank'
                                    href="https://www.facebook.com/mercosoficial"
                                    className="social-media-icon expand-icon"
                                >
                                    <img
                                        src="/images/site/new-home/mercos-no-facebook.svg"
                                        alt="Página oficial da Mercos no Facebook"
                                    />
                                </Link>
                                <Link
                                    target='_blank'
                                    href="https://www.youtube.com/channel/UCBcUDhuM1--cYwhP39dbEFw"
                                    className="social-media-icon expand-icon"
                                >
                                    <img
                                        src="/images/site/new-home/mercos-no-youtube.svg"
                                        alt="Canal oficial da Mercos no Youtube"
                                    />
                                </Link>
                                <Link
                                    target='_blank'
                                    href="https://www.instagram.com/mercosoficial/"
                                    className="social-media-icon expand-icon"
                                >
                                    <img
                                        target='_blank'
                                        src="/images/site/new-home/mercos-no-instagram.svg"
                                        alt="Perfil oficial da Mercos no Instagram"
                                    />
                                </Link>
                                <Link
                                    target='_blank'
                                    href="https://www.linkedin.com/company/mercos/mycompany/"
                                    className="social-media-icon expand-icon"
                                >
                                    <img
                                        src="/images/site/new-home/mercos-no-linkedin.svg"
                                        alt="Página oficial da Mercos no Linkedin"
                                    />
                                </Link>
                                <Link
                                    target='_blank'
                                    href="https://open.spotify.com/show/5HpzDJ8q32r29HoZtVzGi1"
                                    className="social-media-icon expand-icon"
                                >
                                    <img
                                        src="/images/site/new-home/mercos-no-spotify.svg"
                                        alt="Perfil oficial da Mercos no Spotify"
                                    />
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}


// WEBPACK FOOTER //
// /usr/src/site-blog/src/blocks/NewFooter/Footer.jsx